import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import MainTask from "./pages/task/MainTask";
import Courses from "./pages/courses/Courses";
import AuthRegistration from "./pages/auth/AuthRegistration";
import AuthLogin from "./pages/auth/AuthLogin";
import Theory from "./pages/theory/theory";
import Progress from "./pages/progress/Progress";
import Topics from "./pages/topics/Topics";
import PageNotFound from "./pages/page_not_found/PageNotFound";
import Payment from "./pages/payment/Payment";
import SubscriptionSuccess from "./pages/payment/SubscriptionSuccess";
import PublicOffer from "./pages/docs/public_offer"
import PersonalData from "./pages/docs/personal_data"
import PracticeCourse from "./pages/practice_courses/PracticeCourses";
import TheoryPage from "./pages/theory/TheoryPage";
import ReactGA from "react-ga4";

ReactGA.initialize("G-YM6QKCJSE1");

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <Routes>
        <Route path="/practice" element={<MainTask />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/registration" element={<AuthRegistration />} />
        <Route path="/login" element={<AuthLogin />} />
        <Route path="/theory" element={<Theory />} />
        <Route path="/progress" element={<Progress />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/thanks" element={<SubscriptionSuccess />} />
        <Route path="/docs/legal" element={<PublicOffer />} />
        <Route path="/docs/policy" element={<PersonalData />} />
        <Route path="/practice_courses" element={<PracticeCourse />} />
        <Route path="/theory_new" element={<TheoryPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
